
import { ChangeDetectorRef, Component, OnInit, Inject, ViewChild, ElementRef, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { AdminService } from '../../../admin.service';
@Component({
    selector: 'app-certifcate-genarate',
    templateUrl: './certificate.component.html',
    styleUrls: ['./certificate.component.css'],
  })

  export class CertificateGenerate implements OnInit {
    @Input() competitionDetail : any;
    @Input() certiIndex ;
    @Input() topEntry;
    @Output() eventEmitter: EventEmitter<void> = new EventEmitter<void>();

    ngOnInit(): void {
    }

    //  ngAfterViewInit(): void{
    //     this.eventEmitter.emit();
    // }
    ngOnChanges(changes: SimpleChanges) {
        if (changes.certiIndex) {
          this.eventEmitter.emit(this.certiIndex);
        }
      }
}